import Swal from 'sweetalert2';

/** Icono según el diagnóstico global. */
function accessIcon(ok: boolean): 'success' | 'warning' {
  if (ok) return 'success';
  return 'warning';
}

/** Indica si el rol está habilitado. */
function roleOk(check: any): boolean {
  return Boolean(check.roleEnabled);
}

/** Indica si tiene menús asignados. */
function menuOk(check: any): boolean {
  return check.menuCount > 0;
}

/** Indica si tiene entidad y módulos. */
function scopeOk(check: any): boolean {
  return check.hasEntity && check.hasModules;
}

/** Indica si el acceso está completo. */
function accessOk(check: any): boolean {
  return roleOk(check) && menuOk(check) && scopeOk(check);
}

/** Fila del checklist con icono. */
function checkRow(label: string, ok: boolean): string {
  return `<li>${ok ? '✅' : '❌'} ${label}</li>`;
}

/** Ítems del checklist de acceso. */
function checkItems(check: any): [string, boolean][] {
  return [
    ['Rol habilitado', roleOk(check)],
    ['Menús asignados', menuOk(check)],
    ['Módulos asignados', Boolean(check.hasModules)],
    ['Entidad asignada', Boolean(check.hasEntity)],
  ];
}

/** Arma la lista HTML del checklist. */
function listChecklist(items: [string, boolean][]): string {
  let html = '<ul style="text-align:left">';
  for (const [label, ok] of items) html += checkRow(label, ok);
  return html + '</ul>';
}

/** Muestra el diagnóstico de acceso del usuario. */
export function showAccessCheck(check: any): void {
  Swal.fire({ icon: accessIcon(accessOk(check)), title: `Acceso de ${check.mail}`, html: listChecklist(checkItems(check)) });
}
